module.exports = __webpack_public_path__ + "img/73a8c2736d90ca24d038dfe2deacebce.png";